import classnames from 'classnames';
import React from 'react';

type IconSize = 'lg' | '2x' | '3x' | '4x' | '5x';
type IconProps = {
  className?: string;
  fixedWidth?: boolean;
  icon: string;
  size?: IconSize;
};

export default function Icon({
  className,
  icon,
  fixedWidth = false,
  size,
}: IconProps) {
  return (
    <i
      aria-hidden="true"
      className={classnames('icon', `icon-${icon}`, className, {
        'icon-fw': fixedWidth,
        'icon-lg': size === 'lg',
        'icon-2x': size === '2x',
        'icon-3x': size === '3x',
        'icon-4x': size === '4x',
        'icon-5x': size === '5x',
      })}
    />
  );
}
